// import React, { useState } from "react";
// import Scrollbars from "react-custom-scrollbars-2";
// import { Link, useLocation } from "react-router-dom";
// import { SidebarData } from "../../core/json/siderbar_data";
// import HorizontalSidebar from "./horizontalSidebar";
// import { useTranslation } from "react-i18next";
// import { all_routes } from "../../Router/all_routes";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { ChevronsLeft } from "feather-icons-react/build/IconComponents";
// import { useSelector } from "react-redux";
// const Sidebar = () => {

//   const route = all_routes;

//   const Location = useLocation();
//   const { t } = useTranslation();

//   const [subOpen, setSubopen] = useState("");
//   const [subsidebar, setSubsidebar] = useState("");

//   const toggleSidebar = (title) => {
//     if (title == subOpen) {
//       setSubopen("");
//     } else {
//       setSubopen(title);
//     }
//   };

//   const toggleSubsidebar = (subitem) => {
//     if (subitem == subsidebar) {
//       setSubsidebar("");
//     } else {
//       setSubsidebar(subitem);
//     }
//   };

//   const [toggle, SetToggle] = useState(false);
//   const handlesidebar = () => {
//     document.body.classList.toggle("mini-sidebar");
//     SetToggle((current) => !current);
//   };

//   const { expandMenus } = useSelector(
//     (state) => state.themeSetting.expandMenus
//   );
//   const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

//   const expandMenu = () => {
//     document.body.classList.remove("expand-menu");
//   };
//   const expandMenuOpen = () => {
//     document.body.classList.add("expand-menu");
//   };

//   return (
//     <div>
//       <div className={`sidebar ${toggle ? "" : "active"} ${expandMenus || dataLayout === 'layout-hovered' ? "expand-menu" : ""}`} id="sidebar" onMouseLeave={expandMenu}
//         onMouseOver={expandMenuOpen}>
//         <>
//           {/* Logo */}
//           <div className="sidebar-logo">
//             <Link to={route.newdashboard} className="logo logo-normal">
//               <ImageWithBasePath src="assets/img/logo.svg" alt="Img" />
//             </Link>
//             <Link to={route.newdashboard} className="logo logo-white">
//               <ImageWithBasePath src="assets/img/logo-white.svg" alt="Img" />
//             </Link>
//             <Link to={route.newdashboard} className="logo-small">
//               <ImageWithBasePath src="assets/img/logo-small.png" alt="Img" />
//             </Link>
//             <Link id="toggle_btn" to="#" onClick={handlesidebar}>
//               <i data-feather="chevrons-left" />
//               <ChevronsLeft className="feather-16" />
//             </Link>
//           </div>
//           {/* /Logo */}
//           <div className="modern-profile p-3 pb-0">
//             <div className="text-center rounded bg-light p-3 mb-4 border">
//               <div className="avatar avatar-lg online mb-3">
//                 <ImageWithBasePath
//                   src="assets/img/customer/customer15.jpg"
//                   alt="Img"
//                   className="img-fluid rounded-circle"
//                 />
//               </div>
//               <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
//               <p className="fs-12 mb-0">System Admin</p>
//             </div>
//             <div className="sidebar-nav mb-3">
//               <ul
//                 className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
//                 role="tablist"
//               >
//                 <li className="nav-item">
//                   <Link className="nav-link active border-0" to="#">
//                     Menu
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link border-0" to={route.chat}>
//                     Chats
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link className="nav-link border-0" to={route.email}>
//                     Inbox
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//           <div className="sidebar-header p-3 pb-0 pt-2">
//             <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
//               <div className="avatar avatar-md onlin">
//                 <ImageWithBasePath
//                   src="assets/img/customer/customer15.jpg"
//                   alt="Img"
//                   className="img-fluid rounded-circle"
//                 />
//               </div>
//               <div className="text-start sidebar-profile-info ms-2">
//                 <h6 className="fs-14 fw-bold mb-1">Adrian Herman</h6>
//                 <p className="fs-12">System Admin</p>
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-between menu-item mb-3">
//               <div>
//                 <Link to={route.newdashboard} className="btn btn-sm btn-icon bg-light">
//                   <i className="ti ti-layout-grid-remove" />
//                 </Link>
//               </div>
//               <div>
//                 <Link to={route.chat} className="btn btn-sm btn-icon bg-light">
//                   <i className="ti ti-brand-hipchat" />
//                 </Link>
//               </div>
//               <div>
//                 <Link
//                   to={route.email}
//                   className="btn btn-sm btn-icon bg-light position-relative"
//                 >
//                   <i className="ti ti-message" />
//                 </Link>
//               </div>
//               <div className="notification-item">
//                 <Link
//                   to={route.activities}
//                   className="btn btn-sm btn-icon bg-light position-relative"
//                 >
//                   <i className="ti ti-bell" />
//                   <span className="notification-status-dot" />
//                 </Link>
//               </div>
//               <div className="me-0">
//                 <Link
//                   to={route.generalsettings}
//                   className="btn btn-sm btn-icon bg-light"
//                 >
//                   <i className="ti ti-settings" />
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </>
//         <Scrollbars>

//           <div className="sidebar-inner slimscroll">
//             <div id="sidebar-menu" className="sidebar-menu">
//               <ul>
//                 {SidebarData?.map((mainLabel, index) => (
//                   <li className="submenu-open" key={index}>
//                     <h6 className="submenu-hdr">{mainLabel?.label}</h6>
//                     <ul>
//                       {mainLabel?.submenuItems?.map((title, i) => {
//                         let link_array = [];
//                         title?.submenuItems?.map((link) => {
//                           link_array.push(link?.link);
//                           if (link?.submenu) {
//                             link?.submenuItems?.map((item) => {
//                               link_array.push(item?.link);
//                             });
//                           }
//                           return link_array;
//                         });

//                         title.links = link_array;
//                         return (
//                           <React.Fragment key={i}>
//                             {" "}
//                             <li
//                               className={`submenu ${!title?.submenu &&
//                                 Location.pathname === title?.link
//                                 ? "custom-active-hassubroute-false"
//                                 : ""
//                                 }`}
//                             >
//                               <Link
//                                 to={title?.link}
//                                 onClick={() => toggleSidebar(title?.label)}
//                                 className={`${subOpen === title?.label ? "subdrop" : ""
//                                   } ${title?.links?.includes(Location.pathname)
//                                     ? "active"
//                                     : ""
//                                   }`}
//                               >
//                                 <i className={`ti ti-${title.icon} me-2`}></i>
//                                 <span className="custom-active-span">
//                                   {t(title?.label)}
//                                 </span>
//                                 {title?.submenu && (
//                                   <span className="menu-arrow" />
//                                 )}
//                               </Link>
//                               <ul
//                                 style={{
//                                   display:
//                                     subOpen === title?.label ? "block" : "none",
//                                 }}
//                               >
//                                 {title?.submenuItems?.map(
//                                   (item, titleIndex) => (
//                                     <li
//                                       className="submenu submenu-two"
//                                       key={titleIndex}
//                                     >
//                                       <Link
//                                         to={item?.link}
//                                         className={`${item?.submenuItems
//                                           ?.map((link) => link.link)
//                                           .includes(Location.pathname) ||
//                                           item?.link === Location.pathname
//                                           ? "active"
//                                           : ""
//                                           } ${subsidebar === item?.label
//                                             ? "subdrop"
//                                             : ""
//                                           }`}
//                                         onClick={() =>
//                                           toggleSubsidebar(item?.label)
//                                         }
//                                       >
//                                         {item?.label}
//                                         {item?.submenu && (
//                                           <span className="menu-arrow inside-submenu" />
//                                         )}
//                                       </Link>
//                                       <ul
//                                         style={{
//                                           display:
//                                             subsidebar === item?.label
//                                               ? "block"
//                                               : "none",
//                                         }}
//                                       >
//                                         {item?.submenuItems?.map(
//                                           (items, subIndex) => (
//                                             <li key={subIndex}>
//                                               <Link
//                                                 to={items?.link}
//                                                 className={`${subsidebar === items?.label
//                                                   ? "submenu-two subdrop"
//                                                   : "submenu-two"
//                                                   } ${items?.submenuItems
//                                                     ?.map((link) => link.link)
//                                                     .includes(
//                                                       Location.pathname
//                                                     ) ||
//                                                     items?.link ===
//                                                     Location.pathname
//                                                     ? "active"
//                                                     : ""
//                                                   }`}
//                                               >
//                                                 {items?.label}
//                                               </Link>
//                                             </li>
//                                           )
//                                         )}
//                                       </ul>
//                                     </li>
//                                   )
//                                 )}
//                               </ul>
//                             </li>
//                           </React.Fragment>
//                         );
//                       })}
//                     </ul>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </Scrollbars>
//       </div>
//       <HorizontalSidebar />
//       {/* <CollapsedSidebar /> */}
//     </div>
//   );
// };

// export default Sidebar;

import React from "react";
import PropTypes from "prop-types";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";

const Sidebar = ({ isOpen, onClose }) => {
  const isManager = sessionStorage.getItem("isManager") === "true";
  const items = [
    {
      key: "1",
      label: <Link to="/rollcall/teamattendance">Team Attendance</Link>,
    },
    {
      key: "2",
      label: <Link to="/rollcall/bulkattendance">Bulk Attendance</Link>,
    },
    {
      key: "3",
      label: <Link to="/rollcall/manualattendance">Manual Attendance</Link>,
    },
    { key: "4", label: <Link to="/rollcall/teammembers">Team Members</Link> },
    {
      key: "5",
      label: <Link to="/rollcall/leaveapplication">Team Leaves</Link>,
    },
  ];

  const leaveItems = [
    { key: "1", label: <Link to="/rollcall/leaves">My Leaves</Link> },
    { key: "2", label: <Link to="/rollcall/leavesummary">Leave Summary</Link> },
  ];

  const VistingItems = [
    {
      key: "1",
      label: <Link to="/visitor/visitorlist">Visitor List</Link>,
    },
    {
      key: "2",
      label: <Link to="/visitor/visitorreport">Visitor Reports</Link>,
    },
  ];

  return (
    <div
      className={`offcanvas offcanvas-start ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{ visibility: isOpen ? "visible" : "hidden", width: "260px" }}
    >
      <div className="offcanvas-header border-bottom">
        <div className="header-left active">
          <Link to="index.html" className="logo logo-normal">
            {/* <img
              src="assets/img/logo.png"
              alt="Img"
              className="img-fluid w-50"
            /> */}
            <ImageWithBasePath src="assets/img/logo.png" alt="img" />
          </Link>
        </div>
        <button
          type="button"
          className="btn-close text-reset"
          onClick={onClose}
        ></button>
      </div>
      <div className="offcanvas-body p-0">
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <Link
              to="/rollcall/attendance"
              className="btn w-100 text-start d-flex align-items-center"
            >
              <i className="ti ti-layout-grid me-2"></i>Attendance
            </Link>
          </li>

          <li className="list-group-item">
            <button
              className="btn w-100 text-start d-flex align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#leavesCollapse"
            >
              <i className="ti ti-layout-grid me-2"></i> Leaves
              <i className="ti ti-chevron-down ms-auto"></i>
            </button>

            <div className="collapse" id="leavesCollapse">
              <ul className="list-unstyled ps-4 pt-2">
                {leaveItems.map((item) => (
                  <li key={item.key}>
                    <span className="d-block py-1 text-decoration-none">
                      {item.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </li>
          <li className="list-group-item">
            <button
              className="btn w-100 text-start d-flex align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#visitorCollapse"
            >
              <i className="ti ti-layout-grid me-2"></i> Visitor
              <i className="ti ti-chevron-down ms-auto"></i>
            </button>

            <div className="collapse" id="visitorCollapse">
              <ul className="list-unstyled ps-4 pt-2">
                {VistingItems.map((item) => (
                  <li key={item.key}>
                    <span className="d-block py-1 text-decoration-none">
                      {item.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </li>

          {isManager && (
            <li className="list-group-item">
              <button
                className="btn w-100 text-start d-flex align-items-center"
                data-bs-toggle="collapse"
                data-bs-target="#teamsCollapse"
              >
                <i className="ti ti-users-group me-2"></i>
                Teams
                <i className="ti ti-chevron-down ms-auto"></i>
              </button>

              <div className="collapse" id="teamsCollapse">
                <ul className="list-unstyled ps-4 pt-2">
                  {items.map((item) => (
                    <li key={item.key}>
                      {" "}
                      <span className="d-block py-1 text-decoration-none">
                        {item.label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="collapse" id="leavesCollapse">
                <ul className="list-unstyled ps-4 pt-2">
                  {leaveItems.map((item) => (
                    <li key={item.key}>
                      <span className="d-block py-1 text-decoration-none">
                        {item.label}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          )}

          {/* Dropdown Group: Others */}
          {/* <li className="list-group-item">
            <button
              className="btn w-100 text-start d-flex align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#othersCollapse"
              aria-expanded="false"
              aria-controls="othersCollapse"
            >
              <i className="ti ti-chart-bar me-2"></i> Others
              <i className="ti ti-chevron-down ms-auto"></i>
            </button>
            <div className="collapse" id="othersCollapse">
              <ul className="list-unstyled ps-4 pt-2">
                <li>
                  <Link
                    to="/OthersNotifications"
                    className="d-block py-1 text-decoration-none"
                  >
                    Notifications
                  </Link>
                </li>
                <li>
                  <Link
                    to="/OthersJobs"
                    className="d-block py-1 text-decoration-none"
                  >
                    Jobs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/OthersJobStatus"
                    className="d-block py-1 text-decoration-none"
                  >
                    Job Status
                  </Link>
                </li>
                <li>
                  <Link
                    to="/OthersQuery"
                    className="d-block py-1 text-decoration-none"
                  >
                    Query
                  </Link>
                </li>
                <li>
                  <Link
                    to="/OthersDBHealth"
                    className="d-block py-1 text-decoration-none"
                  >
                    DB Health
                  </Link>
                </li>
                <li>
                  <Link
                    to="/OthersSMS"
                    className="d-block py-1 text-decoration-none"
                  >
                    SMS
                  </Link>
                </li>
              </ul>
            </div>
          </li> */}
        </ul>
      </div>
    </div>
  );
};
Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Sidebar;
